var map = {
	"./__tests__/azure.test": "277f",
	"./__tests__/azure.test.ts": "277f",
	"./aws": "3ec6",
	"./aws.vue": "3ec6",
	"./azure": "38ac",
	"./azure.vue": "38ac",
	"./digitalocean": "1077",
	"./digitalocean.vue": "1077",
	"./gcp": "ed3a",
	"./gcp.vue": "ed3a",
	"./generic": "99a8",
	"./generic.vue": "99a8",
	"./harvester": "b984",
	"./harvester.vue": "b984",
	"./linode": "0e8b",
	"./linode.vue": "0e8b",
	"./pnap": "dcb1",
	"./pnap.vue": "dcb1",
	"./s3": "67d1",
	"./s3.vue": "67d1",
	"./vmwarevsphere": "6f9e",
	"./vmwarevsphere.vue": "6f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28b0";